import classes from "./detail.module.scss";

import Flex from "@/components-library/layout/flex";
import ComposedViewHeader from "@/composed-views/composed-view-header";
import Label from "@/components-library/widgets/label";
import ComposedViewSix from "@/composed-views/composed-view-six";
import ComposedViewBannerPartner from "@/composed-views/composed-view-banner-partner";
function Detail({ title, content, mainContent, image, link }) {
  return (
    <Flex
      align="flex-start"
      className={classes.detail}
      direction="column"
      justify="flex-start"
    >
      <ComposedViewHeader title={title} header={"I partner di Prossimiti"} />
      <Label
        align="start"
        size="md"
        color="secondary"
        className={classes.content}
      >
        {content}
      </Label>

      <ComposedViewSix
        title={mainContent.title}
        columnOneTitle={mainContent.columnOneTitle}
        columnOne={mainContent.columnOne}
        columnTwoTitle={mainContent.columnTwoTitle}
        columnTwo={mainContent.columnTwo}
        className={classes.mainContent}
      />

      <ComposedViewBannerPartner
        image={image}
        link={link}
        className={classes.banner}
      />
    </Flex>
  );
}

export default Detail;
